import React, { useEffect, useState } from "react";

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const link = (id, label) => (
        <a
            href={`#${id}`}
            data-testid={`nav-${id}`}
            className="text-[11px] tracking-[0.28em] uppercase text-neutral-400 hover:text-[#f4f4f0] transition-colors duration-300"
        >
            {label}
        </a>
    );

    return (
        <nav
            data-testid="top-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#030303]/85 backdrop-blur-md border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="font-serif-display text-xl tracking-wide text-[#f4f4f0] flex items-center gap-3"
                >
                    <span className="inline-block w-2 h-2 bg-[#7A0000] ember" />
                    <span className="italic">Viktor Varek</span>
                </a>
                <div className="hidden md:flex items-center gap-10">
                    {link("phases", "The Phases")}
                    {link("manifesto", "Manifesto")}
                    {link("author", "Viktor")}
                    {link("pricing", "Acquire")}
                </div>
                <a
                    href="#pricing"
                    data-testid="nav-cta"
                    className="text-[11px] tracking-[0.24em] uppercase border border-[#7A0000]/60 px-4 py-2 text-[#f4f4f0] hover:bg-[#7A0000] transition-colors duration-300"
                >
                    Claim the Code
                </a>
            </div>
        </nav>
    );
}
